import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { useSearchParams } from 'react-router-dom'
import { IDS_REPORT } from '../../../../cartAndOrders/constant'
import { getCompanies } from '../../../../common/filterCompany/store/thunk'
import { Element } from '../../../../common/html/element'
import { Icon } from '../../../../common/html/icon'
import { AddToCart } from '../../../../common/order/cart'
import { Tooltip } from '../../../../common/tooltip'
import EventEmitter, {
  SHOW_POPUP_ERROR,
} from '../../../../helpers/EventEmitter'
import { COMPANY_TYPES } from '../../../../utils/common'
import { TranslateRemoveMultiCompany } from '../../../common/html/text/TranslateCompany'
import { TranslateItemSelect } from '../../../common/html/text/TranslateItem'
import { PopupCopyOrMoveCompany } from '../../../common/popup/PopupCopyOrMoveCompany'
import { PopupDeleteCompany } from '../../../common/popup/PopupDeleteCompany'
import { TYPE_DELETE } from '../../../constant'
import { checkIsSelectAll, getListIdSelectByObj } from '../../../helper'
import { changeFragment } from '../../portfoliosOverview/store/slice/sliceComponent'
import { TYPE_POPUP_MOVE_COPY } from '../constant'
import style from '../index.module.scss'
import {
  removeIdInListIdAll,
  selectAllIdByTerm,
  selectDataCheckBox,
  selectDataHeaderPortfolioDetail,
  unSelectAllCheckbox,
} from '../store/slice'
import {
  delDeleteCompany,
  getHeaderSavedPortfolioDetail,
  postMoveOrCopyCompany,
} from '../store/thunk'

export const InteractiveTable = () => {
  const dispatch = useDispatch()
  const [searchId] = useSearchParams()
  const id = searchId.get('id')

  const checkboxObj = useSelector(selectDataCheckBox('listIdsSelected'))
  const listIdAllByTerm = useSelector(selectDataCheckBox('listIdAllByTerm'))
  const { portfolioName } = useSelector(selectDataHeaderPortfolioDetail) || {}
  const locale = useSelector((state) => state.i18n.locale)

  const isShowInteractive = Object.values(checkboxObj).some(Boolean)
  const numberIdSelected = Object.values(checkboxObj).reduce(
    (accumulator, currentValue) =>
      currentValue ? accumulator + currentValue : accumulator,
    0,
  )
  const isSelectAllIdByTerm = checkIsSelectAll(listIdAllByTerm, checkboxObj)

  const [isShowDelete, setIsShowDelete] = useState(false)
  const [isShowCopy, setShowCopy] = useState(false)
  const [isShowMove, setShowMove] = useState(false)

  const handleSelectAllPortfolio = (value) => {
    dispatch(selectAllIdByTerm(value))
  }

  const handleUnSelectAllPortfolio = () => {
    dispatch(unSelectAllCheckbox())
  }

  const handleDelete = () => {
    setIsShowDelete(true)
  }

  const onSubmitDelete = () => {
    dispatch(
      delDeleteCompany({
        portfolioIds: [id],
        organizationIds: getListIdSelectByObj(checkboxObj),
        deleteType: TYPE_DELETE.IN,
      }),
    )
      .unwrap()
      .then(() => {
        setIsShowDelete(false)
        dispatch(changeFragment())
        dispatch(getHeaderSavedPortfolioDetail({ portfolioId: id }))
        handleUnSelectAllPortfolio()
        dispatch(removeIdInListIdAll(getListIdSelectByObj(checkboxObj)))
      })
      .catch(() => {})
  }

  const onSubmitCopy = (listPort) => {
    dispatch(
      postMoveOrCopyCompany({
        porfolioId: id,
        organizationIds: [...getListIdSelectByObj(checkboxObj)],
        targetPorfolioIds: [...listPort],
        addType: TYPE_DELETE.IN,
        isMove: false,
      }),
    )
      .unwrap()
      .then(() => {
        handleUnSelectAllPortfolio()
        setShowCopy(false)
      })
      .catch(() => {})
  }

  const onSubmitMove = (listPort) => {
    dispatch(
      postMoveOrCopyCompany({
        porfolioId: id,
        organizationIds: [...getListIdSelectByObj(checkboxObj)],
        targetPorfolioIds: [...listPort],
        addType: TYPE_DELETE.IN,
        isMove: true,
      }),
    )
      .unwrap()
      .then(() => {
        handleUnSelectAllPortfolio()
        setShowMove(false)
        dispatch(changeFragment())
        dispatch(getHeaderSavedPortfolioDetail({ portfolioId: id }))
        dispatch(removeIdInListIdAll(getListIdSelectByObj(checkboxObj)))
      })
      .catch(() => {})
  }

  const handleBuyAndAddCart = (isAdd, handleAddCart) => {
    dispatch(
      getCompanies({
        page: 1,
        pageSize: 500,
        organizationIds: [...getListIdSelectByObj(checkboxObj)],
      }),
    )
      .unwrap()
      .then((data) => {
        const listData = data
          .filter((key) =>
            [
              COMPANY_TYPES.BANK,
              COMPANY_TYPES.CORPORATE,
              COMPANY_TYPES.SECURITIES,
            ].includes(key?.companyType),
          )
          .map((item) => ({
            organizationId: item?.organizationId,
            taxCode: item?.taxCode,
            companyName: item?.organizationName,
            languageCode: locale,
            fiinGateReportTypeId: IDS_REPORT.FIINGATE_FACTSHEET,
          }))

        if (!listData.length) {
          EventEmitter.dispatch(SHOW_POPUP_ERROR, {
            messages: [
              <div className="textCenter">
                <Translate
                  reportName="FiinGate FactSheet"
                  value="common.order.popupConfirmationBuyNowOrAddCart.TITLE_LINE_2"
                />
              </div>,
            ],
          })
          return
        }

        handleAddCart(isAdd, listData)
      })
      .catch(() => {})
  }

  return (
    <>
      {isShowInteractive && (
        <Element
          className={['dFlex alignItemsCenter', style.listActionIcon].join(' ')}
        >
          <Element elementName="p" style={{ fontWeight: 600 }}>
            <TranslateItemSelect count={numberIdSelected} />
          </Element>
          {isSelectAllIdByTerm ? (
            <Element
              elementName="p"
              style={{
                fontWeight: 600,
                color: '#2C73E8',
                cursor: 'pointer',
              }}
              onClick={() => handleUnSelectAllPortfolio()}
            >
              <Translate value="library.main.UNSELECT_ALL" />
            </Element>
          ) : (
            <Element
              elementName="p"
              style={{
                fontWeight: 600,
                color: '#2C73E8',
                cursor: 'pointer',
              }}
              onClick={() => handleSelectAllPortfolio(true)}
            >
              <Translate
                value="library.main.SELECT_ALL"
                count={listIdAllByTerm?.length}
              />
            </Element>
          )}
          <Tooltip isI18n tooltipContent="library.main.DELETE">
            <Element
              className={style.icon}
              style={{ backgroundColor: '#f2f7ff' }}
              onClick={handleDelete}
            >
              <Icon
                style={{ color: '#2C73E8', fontSize: 16 }}
                className="icon-trash-fill"
              />
            </Element>
          </Tooltip>

          <Tooltip isI18n tooltipContent="library.main.ADD_CART">
            <AddToCart isFactSheet isFromLibrary>
              {(handleAddCart) => {
                return (
                  <Element
                    className={style.icon}
                    style={{ backgroundColor: '#f2f7ff' }}
                    onClick={() => {
                      handleBuyAndAddCart(true, handleAddCart)
                    }}
                  >
                    <Icon
                      style={{ color: '#3DA967', fontSize: 16 }}
                      className="icon-add-shopping-cart"
                    />
                  </Element>
                )
              }}
            </AddToCart>
          </Tooltip>

          <Tooltip isI18n tooltipContent="library.main.BUY_FIIN">
            <AddToCart isFactSheet isFromLibrary>
              {(handleAddCart) => {
                return (
                  <Element
                    className={style.icon}
                    style={{ backgroundColor: '#f2f7ff' }}
                    onClick={() => {
                      handleBuyAndAddCart(false, handleAddCart)
                    }}
                  >
                    <Icon
                      style={{ color: '#3DA967', fontSize: 16 }}
                      className="icon-money"
                    />
                  </Element>
                )
              }}
            </AddToCart>
          </Tooltip>

          <Tooltip isI18n tooltipContent="library.main.MOVE">
            <Element
              className={style.icon}
              style={{ backgroundColor: '#FBF1E8' }}
              onClick={() => {
                setShowMove(true)
              }}
            >
              <Icon style={{ color: '#E6964C' }} className="icon-read-more" />
            </Element>
          </Tooltip>

          <Tooltip isI18n tooltipContent="library.main.COPY">
            <Element
              className={style.icon}
              style={{ backgroundColor: '#f2f7ff' }}
              onClick={() => {
                setShowCopy(true)
              }}
            >
              <Icon
                style={{ color: '#0553A5', fontSize: 16 }}
                className="icon-content-coppy"
              />
            </Element>
          </Tooltip>
        </Element>
      )}

      {isShowDelete && (
        <PopupDeleteCompany
          isShow={isShowDelete}
          setShow={setIsShowDelete}
          onSubmit={onSubmitDelete}
          renderContent={() => (
            <TranslateRemoveMultiCompany
              count={numberIdSelected}
              portfolioName={portfolioName}
            />
          )}
        />
      )}
      {isShowCopy && (
        <PopupCopyOrMoveCompany
          isShow={isShowCopy}
          setShow={setShowCopy}
          type={TYPE_POPUP_MOVE_COPY.COPY}
          handleApply={onSubmitCopy}
          numberCompany={[...getListIdSelectByObj(checkboxObj)].length}
        />
      )}
      {isShowMove && (
        <PopupCopyOrMoveCompany
          isShow={isShowMove}
          setShow={setShowMove}
          type={TYPE_POPUP_MOVE_COPY.MOVE}
          handleApply={onSubmitMove}
          numberCompany={[...getListIdSelectByObj(checkboxObj)].length}
        />
      )}
    </>
  )
}
